import React, { Component, Fragment } from 'react'
import { strVal } from '../../../modules/Utils'

class DropdownColumn extends Component {
  render() {
    const { record, column, value, onChange, SelectCmp, display, keyAtr, valueAtr, dataIndex, ...rest } = this.props
    return (
      <Fragment>
        {record.editable ? (
          <SelectCmp
            {...rest}
            value={value}
            showSearch
            keyAtr={keyAtr}
            valueAtr={valueAtr}
            style={{ width: '100%' }}
            onChange={(value) => onChange(value, record[dataIndex], column, record)}
          />
        ) : display ? (
          strVal({ display }, 'display')
        ) : (
          strVal({ value }, 'value')
        )}
      </Fragment>
    )
  }
}

DropdownColumn.propTypes = {}
DropdownColumn.defaultProps = { dataIndex: 'key' }

export default DropdownColumn
